module.exports = Object.freeze({
  PUBLIC_ROOT: "/:profileUrl",
  PROFILE: {
    ROOT: "/profile",
    DATA: "/profile/data",
    PAYMENTS: "/profile/payments",
    SETTINGS: "/settings"
  },
  SETTINGS: {
    ROOT: "/settings",
    EDIT: "/settings/profile-edit",
    SETTINGS: "/settings/profile-settings",
    SETTINGS_MOBILE: "/settings/profile-settings-mobile",
  },
  PUBLIC: {
    ROOT: "/public",
    SETUP: "/public/setup",
    LINK: "/public/link",
    PREVIEW_CONNECT_BANK_ACC: "/public/preview-connect",
    FINISH_SETTINGS_ACC: "/public/finish-settings",
    PAYMENT_SUCCEEDED: "/public/payment/succeed",
    PAYMENT_CANCELED: "/public/payment/cancelled",
    STRIPE_CONNECT: "/public/payment/token"
  },
  AUTH: {
    ROOT: "/",
    SIGNIN: "/login",
    SIGNUP: "/signup",
    RESET_PASSWORD: "/reset-password",
    ACTIVATE_ACCOUNT: "/activate-account",
    FORGOT_PASSWORD: "/forgot-password",
  },
});
